export enum ExerciseAction {
  LIST_UNITS = 'list-units',
  LIST_UNIT_STUDENTS = 'list-unit-students',
  DETAIL = 'detail',
  REVIEW = 'review',
}
